export { default } from "./PayOptionDetail";

